import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const FeaturesDefaultProps = {
  ...ClassNameDefaultProps,
  details: {},
};

export const FeaturesPropTypes = {
  ...ClassNamePropTypes,
  details: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        label: PropTypes.string,
        unit: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
};
